import React from "react";

function Header() {
  return (
    <nav className="header">
      <h1 className="title">Simple Note</h1>
    </nav>
  );
}

export default Header;
